@if (treatment(); as treatment) {
  <pr-charted-item-card-v2
    #card="prChartedItemCardV2"
    [expanded]="expandedState()"
    [item]="treatment"
    [selectedSurfaces]="selectedSurfaces()"
    [disabled]="disabled()"
    [compact]="compact()"
    [groupedTreatment]="true"
    [plan]="plan()"
    (itemDelete)="deleteTreatment(treatment)"
    (expandedChanged)="setGroupExpanded($event)"
    (updateChartable)="updateChartable.emit($event)"
  >
    <ng-container ngProjectAs=".drag-handle">
      <ng-content />
    </ng-container>

    <ng-container
      *ngIf="serviceCodeSummary$ | async as serviceCodeSummary"
      ngProjectAs=".header-info"
    >
      <small
        class="mat-caption truncate text-gray-500"
        matTooltipShowDelay="300"
        [matTooltip]="'Service Codes: ' + serviceCodeSummary"
      >
        {{ serviceCodeSummary }}
      </small>
    </ng-container>

    <ng-container ngProjectAs=".category-indicator">
      <pr-treatment-category-indicator
        [category]="treatmentCategory$ | async"
        (categoryChanged)="categoryChanged.emit($event)"
      />
    </ng-container>

    @if (expandedState()) {
      <ng-container ngProjectAs=".expand-all">
        <button
          mat-icon-button
          class="icon-sm"
          aria-label="Toggle treatment"
          [matTooltip]="
            expandAll() ? 'Hide All Treatment' : 'Show All Treatment'
          "
          (click)="toggleExpandAll()"
        >
          <mat-icon>
            <mat-icon>
              {{ expandAll() ? 'unfold_less' : 'unfold_more' }}
            </mat-icon>
          </mat-icon>
        </button>
      </ng-container>
    }

    <ng-container ngProjectAs=".checkbox">
      <pr-charted-item-toolbar
        [disabled]="disabled()"
        [item]="treatment.treatments"
        [step]="step()"
        [plan]="plan()"
      />
    </ng-container>

    <ng-container ngProjectAs=".grouped-treatment-menu">
      <button mat-icon-button class="icon-sm" [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button
          mat-menu-item
          [disabled]="disabled()"
          (click)="addBasePrice(treatment)"
        >
          <mat-icon>price_check</mat-icon>
          Apply Treatment Base Price
        </button>

        <button
          mat-menu-item
          [disabled]="disabled()"
          [matMenuTriggerFor]="selectFeeScheduleMenu"
        >
          <mat-icon>price_change</mat-icon>
          Apply Fee Schedule
        </button>

        <mat-menu #selectFeeScheduleMenu="matMenu">
          <pr-staff-fee-schedule-menu-items
            [feeSchedule]="feeSchedule$ | async"
            (scheduleSelected)="setFeeSchedule($event)"
          />
        </mat-menu>

        <button mat-menu-item [disabled]="disabled()" (click)="editSurfaces()">
          <mat-icon>select_all</mat-icon>
          Add/Change Surfaces
        </button>

        <button
          mat-menu-item
          [disabled]="disabled()"
          (click)="deleteTreatment(treatment)"
        >
          <mat-icon color="warn">delete</mat-icon>
          Delete Treatment Group
        </button>
      </mat-menu>
    </ng-container>

    <ng-container *ngIf="card.collapsible?.expanded">
      <div
        class="grouped-treatment-content flex flex-col"
        cdkDropList
        #nestedDropList="cdkDropList"
        [id]="'nested-' + treatment.uuid"
        [cdkDropListData]="nestedListData()"
        [cdkDropListDisabled]="disabled()"
        [cdkDropListSortingDisabled]="true"
        [cdkDropListConnectedTo]="connectedListIds()"
      >
        @for (
          individualTreatment of treatment.treatments;
          track individualTreatment.uuid
        ) {
          <div class="mx-1">
            <pr-treatment-scope
              cdkDrag
              cdkScrollable
              [cdkDragData]="individualTreatment"
              [cdkDragDisabled]="disabled()"
              [treatment]="individualTreatment"
              [selectedSurfaces]="selectedSurfaces()"
              [expanded]="expandAll()"
              [disabled]="disabled()"
              [compact]="compact()"
              [plan]="plan()"
              [step]="step()"
              [isNested]="true"
              [appointment]="appointment()"
              (treatmentChanged)="treatmentChanged.emit($event)"
              (treatmentDeleted)="treatmentDeleted.emit($event)"
              (updateChartable)="updateChartable.emit($event)"
              (categoryChanged)="categoryChanged.emit($event)"
              (serviceCodeChanged)="
                updateServiceCodes([individualTreatment], $event)
              "
            >
              <mat-icon
                cdkDragHandle
                class="drag-handle icon-sm"
                [ngClass]="{ disabled: disabled() }"
              >
                drag_handle
              </mat-icon>
            </pr-treatment-scope>
          </div>
        }
        @if (disabled() === false) {
          <div class="mx-1">
            <pr-add-service-code-button
              label="Add Service Code To All Surfaces"
              [connectedTo]="elementRef"
              [commonCodes]="commonCodes$ | async"
              [disabled]="disabled()"
              (codeSelected)="updateServiceCodes(treatment.treatments, $event)"
            />
          </div>
        }
      </div>
    </ng-container>
  </pr-charted-item-card-v2>
}
